import { FileHeadphone, Mail, MapPin, Phone } from "lucide-react";
import React from "react";
import { FaVoicemail } from "react-icons/fa";
// import img from "../assets/images/img39.png";

const Manufacturing = () => {
  return (
    <>
      <section className="ax-manufacturing-sec">
        <div className="container">

          {/* HEADER */}
          <div className="ax-manufacturing-title">
            {/* <h2>Manufacturing Excellence in Ayurveda </h2> */}
            <h2>आयुर्वेद में निर्माण उत्कृष्टता </h2>
            {/* <p>
              At TOP TREND AYURVEDA, our manufacturing process is built on the
              foundation of purity, precision, and traditional Ayurvedic
              principles. We ensure that every product is crafted with care,
              maintaining the highest standards of quality and authenticity. 
            </p> */}
          </div>

          {/* SECTION 1 */}
          <div className="row align-items-center mb-5">

            <div className="col-lg-6">
              <div className="custom-manuf-image">

                <img
                  src="../../images/img39.png"
                  alt="Manufacturing"
                  className="ax-manufacturing-img"
                />
              </div>

            </div>

            <div className="col-lg-6 ax-manufacturing-content">
              <h3>Our Manufacturing Process</h3>
              <p>
               <strong> Top Trend Ayurveda A Group of Sun Rise Pharma</strong>  Our manufacturing begins with the careful selection of high-quality
                raw herbs sourced from trusted suppliers and herbal gardens. Each
                ingredient undergoes strict quality checks before entering the
                production process.  At TOP TREND AYURVEDA, delivering excellence in herbal manufacturing means maintaining the highest standards of purity, precision, and authenticity at every stage of production. We carefully transform natural herbs into effective Ayurvedic formulations using a balanced combination of traditional techniques and modern manufacturing practices. Each process, from raw material selection to final packaging, is carried out under strict quality control to ensure safety, consistency, and maximum potency.
              </p>

              <p className="   custom-hindi-text">
                हम पारंपरिक आयुर्वेदिक निर्माण विधियों को आधुनिक तकनीक के साथ मिलाकर उपयोग करते हैं, ताकि उत्पादों में एकरूपता, सुरक्षा और प्रभावशीलता बनी रहे। हर बैच को स्वच्छ और नियंत्रित वातावरण में तैयार किया जाता है, जिससे जड़ी-बूटियों की प्राकृतिक शक्ति सुरक्षित रहती है।
              </p>
              <h4> मुख्य विशेषताएँ:</h4>
              <ul className="ax-manufacturing-list">
                <li className="   custom-hindi-text p-0 m-0"> प्रीमियम गुणवत्ता की कच्ची जड़ी-बूटियाँ</li>
                <li className=" p-0 m-0  custom-hindi-text">पारंपरिक और आधुनिक प्रोसेसिंग तकनीक</li>
                <li className="  p-0 m-0 custom-hindi-text"> स्वच्छ और नियंत्रित वातावरण</li>
                <li className="   custom-hindi-text"> कड़ी गुणवत्ता सुनिश्चितता (क्वालिटी एश्योरेंस)</li>
              </ul>
            </div>

          </div>

          {/* SECTION 2 (CARDS) */}
          <div className="row g-4">

            <div className="col-md-4">
              <div className="ax-manufacturing-card">
                <h4> Quality Control</h4>
                <p>
                  Every product is tested at multiple stages to ensure safety,
                  purity, and effectiveness. We maintain strict quality control
                  standards throughout the process.
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="ax-manufacturing-card">
                <h4> Advanced Technology</h4>
                <p>
                  Our facilities are equipped with modern machinery that supports
                  traditional Ayurvedic formulations while maintaining precision
                  and consistency.
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="ax-manufacturing-card">
                <h4> Packaging & Safety</h4>
                <p>
                  We ensure secure and hygienic packaging to preserve product
                  quality and extend shelf life, delivering safe products to our
                  customers.
                </p>
              </div>
            </div>
          </div>

          <section className="ax-rd-sec py-5">
            <div className="container">

              {/* TITLE */}
              <h2 className="ax-rd-title mb-4">
                Ayurvedic Manufacturing Excellence
              </h2>

              {/* CONTENT */}
              <div className="ax-rd-content">

                {/* <p>
        The manufacturing division at 
        <strong> TOP TREND AYURVEDA </strong> is built on the foundation of 
        purity, precision, and traditional Ayurvedic practices. We focus on 
        transforming carefully selected herbal ingredients into high-quality 
        wellness products using a perfect blend of ancient techniques and modern 
        manufacturing standards.  Our process begins with the sourcing of premium-grade herbs from trusted 
        suppliers and herbal gardens. Each ingredient is thoroughly inspected and 
        processed under controlled conditions to maintain its natural properties. 
        By combining time-tested Ayurvedic preparation methods with advanced 
        technology, we ensure consistency, safety, and effectiveness in every batch 
        we produce.
      </p> */}

                <p className="custom-hindi-text"> <strong>Top Trend Ayurveda A Group of Sun Rise Pharma</strong> का निर्माण विभाग शुद्धता, सटीकता और पारंपरिक आयुर्वेदिक सिद्धांतों की मजबूत नींव पर आधारित है। हम सावधानीपूर्वक चुनी गई जड़ी-बूटियों को उच्च गुणवत्ता वाले वेलनेस उत्पादों में बदलने पर ध्यान केंद्रित करते हैं, जिसमें प्राचीन तकनीकों और आधुनिक निर्माण मानकों का संतुलित समावेश होता है।

                  हमारी प्रक्रिया प्रीमियम गुणवत्ता की जड़ी-बूटियों के चयन से शुरू होती है, जिन्हें विश्वसनीय आपूर्तिकर्ताओं और हर्बल बागानों से प्राप्त किया जाता है। प्रत्येक सामग्री की गहन जांच की जाती है और उसे नियंत्रित परिस्थितियों में संसाधित किया जाता है, ताकि उसकी प्राकृतिक विशेषताएं बनी रहें।

                  पारंपरिक आयुर्वेदिक निर्माण विधियों को उन्नत तकनीक के साथ मिलाकर हम हर बैच में एकरूपता, सुरक्षा और प्रभावशीलता सुनिश्चित करते हैं।
                </p>

                <p>
                  Every stage of manufacturing — from raw material selection and purification
                  to formulation, testing, and packaging — follows strict quality control
                  measures. This ensures that our products retain their potency, authenticity,
                  and therapeutic value while meeting modern safety standards. With a strong commitment to hygiene, quality, and sustainability,
                  <strong> TOP TREND AYURVEDA </strong> ensures that every product is
                  manufactured with care and responsibility. Our goal is to deliver natural,
                  safe, and effective Ayurvedic solutions that support holistic health and
                  long-term well-being.
                </p>
              </div>
            </div>
          </section>



          <section className="ax-contact-manuf-section">
  <style>
    {`
      .ax-contact-manuf-section {
        background-color: #fafaf9; 
        // padding: 80px 0;
        border-top: 1px solid #e5e7eb;
        border-bottom: 1px solid #e5e7eb;
        font-family: sans-serif;
      }
      .ax-contact-manuf-item {
        padding: 30px;
        transition: background-color 0.3s ease;
      }
      .ax-contact-manuf-icon-box {
        width: 54px;
        height: 54px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #ffffff;
        border-radius: 12px;
        color: #b45309; /* Premium Amber */
        margin-bottom: 20px;
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
      }
      .ax-contact-manuf-link {
        text-decoration: none;
        // color: #1e293b;
        font-weight: 500;
        transition: color 0.2s;
        display: inline-block;
        // font-size:22px;
        color:#383836;
      }

      @media(max-width:375px){
      .ax-contact-manuf-link{
      font-size:17px;
      }
      }
      .ax-contact-manuf-link:hover {
        color: #b45309;
      }
      .ax-contact-manuf-divider {
        border-right: 1px solid #e5e7eb;
      }
      .ax-contact-manuf-label {
        font-size: 15px;
        text-transform: uppercase;
        letter-spacing: 1.5px;
        font-weight: 800;
        // color: #94a3b8;
        margin-bottom: 8px;
        // white-space:no-wrap;
      }
      @media (max-width: 991px) {
        .ax-contact-manuf-divider {
          border-right: none;
          border-bottom: 1px solid #e5e7eb;
        }
      }
    `}
  </style>

  <div className="container">
    <div className="row g-0 align-items-stretch">
      
      {/* Address Block */}
      <div className="col-lg-4 ax-contact-manuf-item ax-contact-manuf-divider">
        <div className="ax-contact-manuf-icon-box">
          {/* <FiMapPin size={26} /> */}
           <MapPin size={20} />
        </div>
        <h5 className="ax-contact-manuf-label">Manufacturing  Address</h5>
        <p className=" m-0" style={{ lineHeight: '1.6' }}>
        Sun Rise Ayurveda Company<br />
        VPO - Kalayat, District-kaithal 136117 (Haryana)
        </p>
      </div>

      {/* Phone Block */}
      <div className="col-lg-4 ax-contact-manuf-item ax-contact-manuf-divider">
        <div className="ax-contact-manuf-icon-box">
          
          <Phone size={20} />
        </div>
        <h5 className="ax-contact-manuf-label">Contact Us</h5>
        <a href="tel:+919876543210" className="ax-contact-manuf-link ">
         +91 9812577900 <br/>
         +91 9812577967
        </a>
        {/* <p className="small text-muted mt-2">Available Mon - Sat, 9am to 6pm</p> */}
      </div>

      {/* Email Block */}
      <div className="col-lg-4 ax-contact-manuf-item">
        <div className="ax-contact-manuf-icon-box">
           <Mail size={20} />
        </div>
        <h5 className="ax-contact-manuf-label">Email</h5>
        <a href="mailto:info@manufacturing.com" className="ax-contact-manuf-link ">
       panwarss115@gmail.com
        </a>
        <p className="small text-muted mt-2">Send your query</p>
      </div>

    </div>
  </div>
</section>

          <section className="ax-rd-sec py-5">
            <div className="container">
              {/* TITLE */}
              <h2 className="ax-rd-title mb-4">
                Delivering Excellence in Herbal Manufacturing
              </h2>

              {/* CONTENT */}
              <div className="ax-rd-content">
                <p>
                  At TOP TREND AYURVEDA, delivering excellence in herbal manufacturing means maintaining the highest standards of purity, precision, and authenticity at every stage of production. We carefully transform natural herbs into effective Ayurvedic formulations using a balanced combination of traditional techniques and modern manufacturing practices. Each process, from raw material selection to final packaging, is carried out under strict quality control to ensure safety, consistency, and maximum potency. Our commitment to excellence ensures that every product reflects the true essence of Ayurveda while meeting the demands of modern wellness, providing reliable and natural solutions for a healthier life.
                </p>
                <p>
                  At TOP TREND AYURVEDA, our approach to herbal manufacturing is centered on creating a seamless connection between nature and modern wellness needs. We focus on transforming carefully selected Ayurvedic herbs into high-quality products through a refined process that emphasizes consistency, safety, and effectiveness. Every stage of production is guided by strict standards and a deep understanding of traditional formulations, ensuring that the natural benefits of each ingredient are preserved. By combining expertise, innovation, and responsible manufacturing practices, we deliver products that support holistic health and reflect our commitment to purity and trust.
                </p>
              </div>
            </div>
          </section>
        </div>
      </section>
    </>
  );
};

export default Manufacturing;